/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_No_EventsInputs */

const en_calendar_no_events = /** @type {(inputs: Calendar_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reminders`)
};

const pt_br2_calendar_no_events = /** @type {(inputs: Calendar_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum lembrete`)
};

/**
* | output |
* | --- |
* | "No reminders" |
*
* @param {Calendar_No_EventsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_no_events = /** @type {((inputs?: Calendar_No_EventsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_No_EventsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_no_events(inputs)
	return pt_br2_calendar_no_events(inputs)
});